module.exports = __webpack_public_path__ + "img/1-4.7348ad3f.png";